// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonValidation = {
  required: "Please enter ${label}",
  stringMin: "${label} must be at least ${min} characters",
  stringMax: "${label} must be at most ${max} characters",
  numberRange: "${label} must be between ${min} and ${max}",
  types: {
    email: "${label} is not a valid email address",
    number: "${label} is not a valid number",
    url: "${label} is not a valid URL",
  },
} as const;
